/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "ApplicationType": {
                "values": {
                  "APPLICATION_INVALID_TYPE": 0,
                  "SQUARE_POS": 1,
                  "RETAIL": 2,
                  "RESTAURANT": 3,
                  "INVOICES": 4,
                  "APPOINTMENTS": 5,
                  "KDS": 6,
                  "TERMINAL_API": 7,
                  "READER_SDK": 8,
                  "FNB_KIOSK": 9,
                  "KIOSK": 10
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.ApplicationType) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ApplicationType @ squareup/devices/external/application_type.proto at 11:1
 */
export const ApplicationType = $root.lookupEnum('squareup.connect.v2.ApplicationType').values;